/**
 * Pipeline have information about the pipeline process
 */

import { PipelineProcess } from './pipeline-process';

export interface Pipeline {
    process: PipelineProcess;
}
